// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WordAddinRouteImport } from './routes/word-addin'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TerminiRouteImport } from './routes/termini'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SicurezzaRouteImport } from './routes/sicurezza'
import { Route as RimborsiRouteImport } from './routes/rimborsi'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as ModuliRouteImport } from './routes/moduli'
import { Route as LoginRouteImport } from './routes/login'
import { Route as GdprRouteImport } from './routes/gdpr'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as ContattiRouteImport } from './routes/contatti'
import { Route as ConformitaAiActRouteImport } from './routes/conformita-ai-act'
import { Route as ChiSiamoRouteImport } from './routes/chi-siamo'
import { Route as BeleadRouteImport } from './routes/belead'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GlossarioIndexRouteImport } from './routes/glossario.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as GlossarioSlugRouteImport } from './routes/glossario.$slug'
import { Route as FunzionalitaRicercaLegaleAiRouteImport } from './routes/funzionalita.ricerca-legale-ai'
import { Route as FunzionalitaRedazioneAssistitaRouteImport } from './routes/funzionalita.redazione-assistita'
import { Route as FunzionalitaAnalisiDocumentiRouteImport } from './routes/funzionalita.analisi-documenti'
import { Route as DevUiPreviewRouteImport } from './routes/dev.ui-preview'
import { Route as DevLogoPreviewRouteImport } from './routes/dev.logo-preview'
import { Route as ConfrontoLexaiproVsRicercaManualeRouteImport } from './routes/confronto.lexaipro-vs-ricerca-manuale'
import { Route as ConfrontoLexaiproVsChatgptRouteImport } from './routes/confronto.lexaipro-vs-chatgpt'
import { Route as CasiUsoUfficioLegaleAziendaleRouteImport } from './routes/casi-uso.ufficio-legale-aziendale'
import { Route as CasiUsoStudiLegaliPiccoliRouteImport } from './routes/casi-uso.studi-legali-piccoli'
import { Route as CasiUsoStudiLegaliMediRouteImport } from './routes/casi-uso.studi-legali-medi'
import { Route as CasiUsoAvvocatoSingoloRouteImport } from './routes/casi-uso.avvocato-singolo'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AreeDirittoTributarioRouteImport } from './routes/aree.diritto-tributario'
import { Route as AreeDirittoSocietarioRouteImport } from './routes/aree.diritto-societario'
import { Route as AreeDirittoPenaleRouteImport } from './routes/aree.diritto-penale'
import { Route as AreeDirittoDiFamigliaRouteImport } from './routes/aree.diritto-di-famiglia'
import { Route as AreeDirittoDelLavoroRouteImport } from './routes/aree.diritto-del-lavoro'
import { Route as AreeDirittoCivileRouteImport } from './routes/aree.diritto-civile'
import { Route as AuthenticatedAppIndexRouteImport } from './routes/_authenticated.app.index'
import { Route as AuthenticatedAppUpgradeRouteImport } from './routes/_authenticated.app.upgrade'
import { Route as AuthenticatedAppTemplatesRouteImport } from './routes/_authenticated.app.templates'
import { Route as AuthenticatedAppTeamRouteImport } from './routes/_authenticated.app.team'
import { Route as AuthenticatedAppSupportoRouteImport } from './routes/_authenticated.app.supporto'
import { Route as AuthenticatedAppSettingsRouteImport } from './routes/_authenticated.app.settings'
import { Route as AuthenticatedAppResearchRouteImport } from './routes/_authenticated.app.research'
import { Route as AuthenticatedAppModuliRouteImport } from './routes/_authenticated.app.moduli'
import { Route as AuthenticatedAppMattersRouteImport } from './routes/_authenticated.app.matters'
import { Route as AuthenticatedAppLibraryRouteImport } from './routes/_authenticated.app.library'
import { Route as AuthenticatedAppHistoryRouteImport } from './routes/_authenticated.app.history'
import { Route as AuthenticatedAppGeneratorRouteImport } from './routes/_authenticated.app.generator'
import { Route as AuthenticatedAppDraftingRouteImport } from './routes/_authenticated.app.drafting'
import { Route as AuthenticatedAppDocumentsRouteImport } from './routes/_authenticated.app.documents'
import { Route as AuthenticatedAppDashboardRouteImport } from './routes/_authenticated.app.dashboard'
import { Route as AuthenticatedAppClientsRouteImport } from './routes/_authenticated.app.clients'
import { Route as AuthenticatedAppCalendarRouteImport } from './routes/_authenticated.app.calendar'
import { Route as AuthenticatedAppBillingRouteImport } from './routes/_authenticated.app.billing'
import { Route as AuthenticatedAppAnalysisRouteImport } from './routes/_authenticated.app.analysis'
import { Route as AuthenticatedAppAnalysesRouteImport } from './routes/_authenticated.app.analyses'
import { Route as AuthenticatedAppAgentiRouteImport } from './routes/_authenticated.app.agenti'
import { Route as AuthenticatedAppAdminRouteImport } from './routes/_authenticated.app.admin'
import { Route as AuthenticatedAppChatMatterIdRouteImport } from './routes/_authenticated.app.chat.$matterId'
import { Route as AuthenticatedAppResearchCompareRouteImport } from './routes/_authenticated.app.research.compare'
import { Route as AuthenticatedAppMattersMatterIdRouteImport } from './routes/_authenticated.app.matters.$matterId'
import { Route as AuthenticatedAppAgentiStoricoRouteImport } from './routes/_authenticated.app.agenti.storico'
import { Route as AuthenticatedAppAgentiDashboardRouteImport } from './routes/_authenticated.app.agenti.dashboard'
import { Route as AuthenticatedAppAdminWebhooksRouteImport } from './routes/_authenticated.app.admin.webhooks'
import { Route as AuthenticatedAppAdminSupportRouteImport } from './routes/_authenticated.app.admin.support'
import { Route as AuthenticatedAppAdminSubscriptionsRouteImport } from './routes/_authenticated.app.admin.subscriptions'
import { Route as AuthenticatedAppAdminModulesRouteImport } from './routes/_authenticated.app.admin.modules'
import { Route as AuthenticatedAppAdminModuleSyncRouteImport } from './routes/_authenticated.app.admin.module-sync'
import { Route as AuthenticatedAppAdminErrorsRouteImport } from './routes/_authenticated.app.admin.errors'
import { Route as AuthenticatedAppAdminAutomationsRouteImport } from './routes/_authenticated.app.admin.automations'
import { Route as AuthenticatedAppAdminAuditRouteImport } from './routes/_authenticated.app.admin.audit'

const WordAddinRoute = WordAddinRouteImport.update({
            id: '/word-addin',path: '/word-addin',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TerminiRoute = TerminiRouteImport.update({
            id: '/termini',path: '/termini',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SicurezzaRoute = SicurezzaRouteImport.update({
            id: '/sicurezza',path: '/sicurezza',getParentRoute: () => rootRouteImport
          })
const RimborsiRoute = RimborsiRouteImport.update({
            id: '/rimborsi',path: '/rimborsi',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const ModuliRoute = ModuliRouteImport.update({
            id: '/moduli',path: '/moduli',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const GdprRoute = GdprRouteImport.update({
            id: '/gdpr',path: '/gdpr',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FeaturesRoute = FeaturesRouteImport.update({
            id: '/features',path: '/features',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const ContattiRoute = ContattiRouteImport.update({
            id: '/contatti',path: '/contatti',getParentRoute: () => rootRouteImport
          })
const ConformitaAiActRoute = ConformitaAiActRouteImport.update({
            id: '/conformita-ai-act',path: '/conformita-ai-act',getParentRoute: () => rootRouteImport
          })
const ChiSiamoRoute = ChiSiamoRouteImport.update({
            id: '/chi-siamo',path: '/chi-siamo',getParentRoute: () => rootRouteImport
          })
const BeleadRoute = BeleadRouteImport.update({
            id: '/belead',path: '/belead',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const GlossarioIndexRoute = GlossarioIndexRouteImport.update({
            id: '/glossario/',path: '/glossario/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const GlossarioSlugRoute = GlossarioSlugRouteImport.update({
            id: '/glossario/$slug',path: '/glossario/$slug',getParentRoute: () => rootRouteImport
          })
const FunzionalitaRicercaLegaleAiRoute = FunzionalitaRicercaLegaleAiRouteImport.update({
            id: '/funzionalita/ricerca-legale-ai',path: '/funzionalita/ricerca-legale-ai',getParentRoute: () => rootRouteImport
          })
const FunzionalitaRedazioneAssistitaRoute = FunzionalitaRedazioneAssistitaRouteImport.update({
            id: '/funzionalita/redazione-assistita',path: '/funzionalita/redazione-assistita',getParentRoute: () => rootRouteImport
          })
const FunzionalitaAnalisiDocumentiRoute = FunzionalitaAnalisiDocumentiRouteImport.update({
            id: '/funzionalita/analisi-documenti',path: '/funzionalita/analisi-documenti',getParentRoute: () => rootRouteImport
          })
const DevUiPreviewRoute = DevUiPreviewRouteImport.update({
            id: '/dev/ui-preview',path: '/dev/ui-preview',getParentRoute: () => rootRouteImport
          })
const DevLogoPreviewRoute = DevLogoPreviewRouteImport.update({
            id: '/dev/logo-preview',path: '/dev/logo-preview',getParentRoute: () => rootRouteImport
          })
const ConfrontoLexaiproVsRicercaManualeRoute = ConfrontoLexaiproVsRicercaManualeRouteImport.update({
            id: '/confronto/lexaipro-vs-ricerca-manuale',path: '/confronto/lexaipro-vs-ricerca-manuale',getParentRoute: () => rootRouteImport
          })
const ConfrontoLexaiproVsChatgptRoute = ConfrontoLexaiproVsChatgptRouteImport.update({
            id: '/confronto/lexaipro-vs-chatgpt',path: '/confronto/lexaipro-vs-chatgpt',getParentRoute: () => rootRouteImport
          })
const CasiUsoUfficioLegaleAziendaleRoute = CasiUsoUfficioLegaleAziendaleRouteImport.update({
            id: '/casi-uso/ufficio-legale-aziendale',path: '/casi-uso/ufficio-legale-aziendale',getParentRoute: () => rootRouteImport
          })
const CasiUsoStudiLegaliPiccoliRoute = CasiUsoStudiLegaliPiccoliRouteImport.update({
            id: '/casi-uso/studi-legali-piccoli',path: '/casi-uso/studi-legali-piccoli',getParentRoute: () => rootRouteImport
          })
const CasiUsoStudiLegaliMediRoute = CasiUsoStudiLegaliMediRouteImport.update({
            id: '/casi-uso/studi-legali-medi',path: '/casi-uso/studi-legali-medi',getParentRoute: () => rootRouteImport
          })
const CasiUsoAvvocatoSingoloRoute = CasiUsoAvvocatoSingoloRouteImport.update({
            id: '/casi-uso/avvocato-singolo',path: '/casi-uso/avvocato-singolo',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const AreeDirittoTributarioRoute = AreeDirittoTributarioRouteImport.update({
            id: '/aree/diritto-tributario',path: '/aree/diritto-tributario',getParentRoute: () => rootRouteImport
          })
const AreeDirittoSocietarioRoute = AreeDirittoSocietarioRouteImport.update({
            id: '/aree/diritto-societario',path: '/aree/diritto-societario',getParentRoute: () => rootRouteImport
          })
const AreeDirittoPenaleRoute = AreeDirittoPenaleRouteImport.update({
            id: '/aree/diritto-penale',path: '/aree/diritto-penale',getParentRoute: () => rootRouteImport
          })
const AreeDirittoDiFamigliaRoute = AreeDirittoDiFamigliaRouteImport.update({
            id: '/aree/diritto-di-famiglia',path: '/aree/diritto-di-famiglia',getParentRoute: () => rootRouteImport
          })
const AreeDirittoDelLavoroRoute = AreeDirittoDelLavoroRouteImport.update({
            id: '/aree/diritto-del-lavoro',path: '/aree/diritto-del-lavoro',getParentRoute: () => rootRouteImport
          })
const AreeDirittoCivileRoute = AreeDirittoCivileRouteImport.update({
            id: '/aree/diritto-civile',path: '/aree/diritto-civile',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAppIndexRoute = AuthenticatedAppIndexRouteImport.update({
            id: '/app/',path: '/app/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppUpgradeRoute = AuthenticatedAppUpgradeRouteImport.update({
            id: '/app/upgrade',path: '/app/upgrade',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppTemplatesRoute = AuthenticatedAppTemplatesRouteImport.update({
            id: '/app/templates',path: '/app/templates',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppTeamRoute = AuthenticatedAppTeamRouteImport.update({
            id: '/app/team',path: '/app/team',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppSupportoRoute = AuthenticatedAppSupportoRouteImport.update({
            id: '/app/supporto',path: '/app/supporto',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppSettingsRoute = AuthenticatedAppSettingsRouteImport.update({
            id: '/app/settings',path: '/app/settings',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppResearchRoute = AuthenticatedAppResearchRouteImport.update({
            id: '/app/research',path: '/app/research',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppModuliRoute = AuthenticatedAppModuliRouteImport.update({
            id: '/app/moduli',path: '/app/moduli',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppMattersRoute = AuthenticatedAppMattersRouteImport.update({
            id: '/app/matters',path: '/app/matters',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppLibraryRoute = AuthenticatedAppLibraryRouteImport.update({
            id: '/app/library',path: '/app/library',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppHistoryRoute = AuthenticatedAppHistoryRouteImport.update({
            id: '/app/history',path: '/app/history',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppGeneratorRoute = AuthenticatedAppGeneratorRouteImport.update({
            id: '/app/generator',path: '/app/generator',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppDraftingRoute = AuthenticatedAppDraftingRouteImport.update({
            id: '/app/drafting',path: '/app/drafting',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppDocumentsRoute = AuthenticatedAppDocumentsRouteImport.update({
            id: '/app/documents',path: '/app/documents',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppDashboardRoute = AuthenticatedAppDashboardRouteImport.update({
            id: '/app/dashboard',path: '/app/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppClientsRoute = AuthenticatedAppClientsRouteImport.update({
            id: '/app/clients',path: '/app/clients',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppCalendarRoute = AuthenticatedAppCalendarRouteImport.update({
            id: '/app/calendar',path: '/app/calendar',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppBillingRoute = AuthenticatedAppBillingRouteImport.update({
            id: '/app/billing',path: '/app/billing',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppAnalysisRoute = AuthenticatedAppAnalysisRouteImport.update({
            id: '/app/analysis',path: '/app/analysis',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppAnalysesRoute = AuthenticatedAppAnalysesRouteImport.update({
            id: '/app/analyses',path: '/app/analyses',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppAgentiRoute = AuthenticatedAppAgentiRouteImport.update({
            id: '/app/agenti',path: '/app/agenti',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppAdminRoute = AuthenticatedAppAdminRouteImport.update({
            id: '/app/admin',path: '/app/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppChatMatterIdRoute = AuthenticatedAppChatMatterIdRouteImport.update({
            id: '/app/chat/$matterId',path: '/app/chat/$matterId',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppResearchCompareRoute = AuthenticatedAppResearchCompareRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => AuthenticatedAppResearchRoute
          })
const AuthenticatedAppMattersMatterIdRoute = AuthenticatedAppMattersMatterIdRouteImport.update({
            id: '/$matterId',path: '/$matterId',getParentRoute: () => AuthenticatedAppMattersRoute
          })
const AuthenticatedAppAgentiStoricoRoute = AuthenticatedAppAgentiStoricoRouteImport.update({
            id: '/storico',path: '/storico',getParentRoute: () => AuthenticatedAppAgentiRoute
          })
const AuthenticatedAppAgentiDashboardRoute = AuthenticatedAppAgentiDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedAppAgentiRoute
          })
const AuthenticatedAppAdminWebhooksRoute = AuthenticatedAppAdminWebhooksRouteImport.update({
            id: '/webhooks',path: '/webhooks',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminSupportRoute = AuthenticatedAppAdminSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminSubscriptionsRoute = AuthenticatedAppAdminSubscriptionsRouteImport.update({
            id: '/subscriptions',path: '/subscriptions',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminModulesRoute = AuthenticatedAppAdminModulesRouteImport.update({
            id: '/modules',path: '/modules',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminModuleSyncRoute = AuthenticatedAppAdminModuleSyncRouteImport.update({
            id: '/module-sync',path: '/module-sync',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminErrorsRoute = AuthenticatedAppAdminErrorsRouteImport.update({
            id: '/errors',path: '/errors',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminAutomationsRoute = AuthenticatedAppAdminAutomationsRouteImport.update({
            id: '/automations',path: '/automations',getParentRoute: () => AuthenticatedAppAdminRoute
          })
const AuthenticatedAppAdminAuditRoute = AuthenticatedAppAdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AuthenticatedAppAdminRoute
          })





const AuthenticatedAppAdminRouteChildren = {
  AuthenticatedAppAdminAuditRoute: AuthenticatedAppAdminAuditRoute,AuthenticatedAppAdminAutomationsRoute: AuthenticatedAppAdminAutomationsRoute,AuthenticatedAppAdminErrorsRoute: AuthenticatedAppAdminErrorsRoute,AuthenticatedAppAdminModuleSyncRoute: AuthenticatedAppAdminModuleSyncRoute,AuthenticatedAppAdminModulesRoute: AuthenticatedAppAdminModulesRoute,AuthenticatedAppAdminSubscriptionsRoute: AuthenticatedAppAdminSubscriptionsRoute,AuthenticatedAppAdminSupportRoute: AuthenticatedAppAdminSupportRoute,AuthenticatedAppAdminWebhooksRoute: AuthenticatedAppAdminWebhooksRoute
}

const AuthenticatedAppAdminRouteWithChildren = AuthenticatedAppAdminRoute._addFileChildren(AuthenticatedAppAdminRouteChildren)




const AuthenticatedAppAgentiRouteChildren = {
  AuthenticatedAppAgentiDashboardRoute: AuthenticatedAppAgentiDashboardRoute,AuthenticatedAppAgentiStoricoRoute: AuthenticatedAppAgentiStoricoRoute
}

const AuthenticatedAppAgentiRouteWithChildren = AuthenticatedAppAgentiRoute._addFileChildren(AuthenticatedAppAgentiRouteChildren)




const AuthenticatedAppMattersRouteChildren = {
  AuthenticatedAppMattersMatterIdRoute: AuthenticatedAppMattersMatterIdRoute
}

const AuthenticatedAppMattersRouteWithChildren = AuthenticatedAppMattersRoute._addFileChildren(AuthenticatedAppMattersRouteChildren)




const AuthenticatedAppResearchRouteChildren = {
  AuthenticatedAppResearchCompareRoute: AuthenticatedAppResearchCompareRoute
}

const AuthenticatedAppResearchRouteWithChildren = AuthenticatedAppResearchRoute._addFileChildren(AuthenticatedAppResearchRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAppAdminRoute: AuthenticatedAppAdminRouteWithChildren,AuthenticatedAppAgentiRoute: AuthenticatedAppAgentiRouteWithChildren,AuthenticatedAppAnalysesRoute: AuthenticatedAppAnalysesRoute,AuthenticatedAppAnalysisRoute: AuthenticatedAppAnalysisRoute,AuthenticatedAppBillingRoute: AuthenticatedAppBillingRoute,AuthenticatedAppCalendarRoute: AuthenticatedAppCalendarRoute,AuthenticatedAppClientsRoute: AuthenticatedAppClientsRoute,AuthenticatedAppDashboardRoute: AuthenticatedAppDashboardRoute,AuthenticatedAppDocumentsRoute: AuthenticatedAppDocumentsRoute,AuthenticatedAppDraftingRoute: AuthenticatedAppDraftingRoute,AuthenticatedAppGeneratorRoute: AuthenticatedAppGeneratorRoute,AuthenticatedAppHistoryRoute: AuthenticatedAppHistoryRoute,AuthenticatedAppLibraryRoute: AuthenticatedAppLibraryRoute,AuthenticatedAppMattersRoute: AuthenticatedAppMattersRouteWithChildren,AuthenticatedAppModuliRoute: AuthenticatedAppModuliRoute,AuthenticatedAppResearchRoute: AuthenticatedAppResearchRouteWithChildren,AuthenticatedAppSettingsRoute: AuthenticatedAppSettingsRoute,AuthenticatedAppSupportoRoute: AuthenticatedAppSupportoRoute,AuthenticatedAppTeamRoute: AuthenticatedAppTeamRoute,AuthenticatedAppTemplatesRoute: AuthenticatedAppTemplatesRoute,AuthenticatedAppUpgradeRoute: AuthenticatedAppUpgradeRoute,AuthenticatedAppIndexRoute: AuthenticatedAppIndexRoute,AuthenticatedAppChatMatterIdRoute: AuthenticatedAppChatMatterIdRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,BeleadRoute: BeleadRoute,ChiSiamoRoute: ChiSiamoRoute,ConformitaAiActRoute: ConformitaAiActRoute,ContattiRoute: ContattiRoute,DemoRoute: DemoRoute,FeaturesRoute: FeaturesRoute,ForgotPasswordRoute: ForgotPasswordRoute,GdprRoute: GdprRoute,LoginRoute: LoginRoute,ModuliRoute: ModuliRoute,OnboardingRoute: OnboardingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,RimborsiRoute: RimborsiRoute,SicurezzaRoute: SicurezzaRoute,SignupRoute: SignupRoute,TerminiRoute: TerminiRoute,UnsubscribeRoute: UnsubscribeRoute,WordAddinRoute: WordAddinRoute,AreeDirittoCivileRoute: AreeDirittoCivileRoute,AreeDirittoDelLavoroRoute: AreeDirittoDelLavoroRoute,AreeDirittoDiFamigliaRoute: AreeDirittoDiFamigliaRoute,AreeDirittoPenaleRoute: AreeDirittoPenaleRoute,AreeDirittoSocietarioRoute: AreeDirittoSocietarioRoute,AreeDirittoTributarioRoute: AreeDirittoTributarioRoute,BlogSlugRoute: BlogSlugRoute,CasiUsoAvvocatoSingoloRoute: CasiUsoAvvocatoSingoloRoute,CasiUsoStudiLegaliMediRoute: CasiUsoStudiLegaliMediRoute,CasiUsoStudiLegaliPiccoliRoute: CasiUsoStudiLegaliPiccoliRoute,CasiUsoUfficioLegaleAziendaleRoute: CasiUsoUfficioLegaleAziendaleRoute,ConfrontoLexaiproVsChatgptRoute: ConfrontoLexaiproVsChatgptRoute,ConfrontoLexaiproVsRicercaManualeRoute: ConfrontoLexaiproVsRicercaManualeRoute,DevLogoPreviewRoute: DevLogoPreviewRoute,DevUiPreviewRoute: DevUiPreviewRoute,FunzionalitaAnalisiDocumentiRoute: FunzionalitaAnalisiDocumentiRoute,FunzionalitaRedazioneAssistitaRoute: FunzionalitaRedazioneAssistitaRoute,FunzionalitaRicercaLegaleAiRoute: FunzionalitaRicercaLegaleAiRoute,GlossarioSlugRoute: GlossarioSlugRoute,BlogIndexRoute: BlogIndexRoute,GlossarioIndexRoute: GlossarioIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)